import style from "./SimpleTable.module.css";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import excelIcon from "resources/img/excelIcon.png";
import {
  forwardRef,
  useContext,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import Center from "layouts/wrapper/Center";
import Inline from "layouts/container/Inline";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import CheckCircleGroup from "components/inputs/checkBox/CheckCircleGroup";
import AdminTableRow from "./AdminTableRow";

import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { requester } from "App";
import NiceModal from "@ebay/nice-modal-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import CheckCircle from "components/inputs/checkBox/CheckCircle";
import memoIcon from "resources/img/memoIcon.png";
import clsx from "classnames";
import ExcelDownloadButton from "./ExcelDownloadButton";
import { toast } from "react-toastify";
import ExcelUploadButton from "./ExcelUploadButton";
import ToolTip from "components/tooltip/tooltip";
import zIndex from "@mui/material/styles/zIndex";
import FlexGrid from "layouts/flex/FlexGrid";
import AdminCustomButton from "components/buttons/AdminCustomButton";
import { isValid } from "date-fns";

function SimpleTable(props) {
  const {
    theader,
    count,
    data,
    justifyContent,
    type,
    reset,
    research,
    output,
    page,
    maxPage,
    setPage,
    limit,
  } = props;
  // const { isMobile } = useContext(BrowserDetectContext);
  const isMobile = false;
  const [tableList, setTableList] = useState();
  const [indexes, setIndexes] = useState([]);
  const checkGroup = useRef();
  useEffect(() => {
    setTableList(data);
  }, [data]);

  const onCheckGroupCallback = (checkedIndex, value) => {
    let selectedRows = [];

    checkedIndex &&
      checkedIndex.forEach((selectedIndex, index) => {
        selectedRows.push(data[selectedIndex]);
      });
    setIndexes(checkedIndex);

    props.callback && props.callback(selectedRows);
  };
  const checkBoxStyle = {};
  const callback = (value) => {
    if (props.cancelCallback) {
      props.cancelCallback(value);
    }
  };
  const onChange = (value) => {
    if (value) {
      const index = tableList.findIndex((item) => item.id === value.id);

      if (index !== -1) {
        const updatedData = [...data];
        updatedData[index] = value;
        setTableList(updatedData);
      }
    }
  };
  useEffect(() => {
    if (reset || research) {
      checkGroup.current.reset();
      setIndexes([]);
    }
  }, [reset, research]);
  return (
    <div>
      {data && theader && (
        <VerticalFlex>
          <FlexChild padding={"0px 20px 0px 20px"}>
            <HorizontalFlex gap={20}>
              <FlexChild width={"max-content"}>
                <Center width={"100%"} textAlign={"left"}>
                  <Inline>
                    <P>검색결과 : </P>
                    <P weight={"bold"} color={"var(--admin-main-color)"}>
                      {count || data?.length}
                    </P>
                    <P>건</P>
                  </Inline>
                </Center>
              </FlexChild>
              {/* {props.upload ? (
                <FlexChild>
                  <HorizontalFlex>
                    <FlexChild width={"max-content"}>
                      <P>재고 일괄수정 : </P>
                    </FlexChild>
                    <FlexChild>
                      <ExcelUploadButton />
                    </FlexChild>
                  </HorizontalFlex>
                </FlexChild>
              ) : null} */}
              <HorizontalFlex
                width={"max-content"}
                justifyContent={"flex-end"}
                gap={10}
              >
                {!props.buttonSplit &&
                  props.buttons?.map((button, index) => (
                    <AdminCustomButton
                      key={`${button.label}_${index}`}
                      type={button?.type || "normal"}
                      className={button?.className}
                      style={button?.style}
                      onClick={() => button?.onClick?.(data, indexes)}
                      onChange={(input) =>
                        button?.onChange?.(input, data, indexes)
                      }
                      text={button.label}
                    />
                  ))}
              </HorizontalFlex>
            </HorizontalFlex>
          </FlexChild>
          {props.buttonSplit && (
            <FlexChild padding={"10px 20px 0px 20px"}>
              <HorizontalFlex>
                {props.buttons?.map((button, index) => (
                  <AdminCustomButton
                    key={`${button.label}_${index}`}
                    type={button?.type || "normal"}
                    className={button?.className}
                    style={button?.style}
                    onClick={() => button?.onClick?.(data, indexes)}
                    onChange={(input) =>
                      button?.onChange?.(input, data, indexes)
                    }
                    text={button.label}
                  />
                ))}
              </HorizontalFlex>
            </FlexChild>
          )}
          <FlexChild padding={20}>
            <CheckCircleGroup
              ref={checkGroup}
              key={props.keyword}
              style={checkBoxStyle}
              gap={10}
              callback={onCheckGroupCallback}
              padding={10}
              backgroundColor={"#f5f6fb"}
              labelWidth={30}
              borderTop={"1px solid #ddd"}
              borderBottom={"1px solid #ddd"}
              headerGap={30}
              header={!isMobile && theader}
              justifyContent={justifyContent}
            >
              {tableList &&
                tableList.length > 0 &&
                tableList.map((row, index) => {
                  return (
                    <SimpleTableRow
                      vendor={props.vendor}
                      productStatus={props.productStatus}
                      onChange={onChange}
                      cancelCallback={callback}
                      header={theader}
                      data={row}
                      key={`simple_${props.index}`}
                      index={index}
                      justifyContent={justifyContent}
                      type={type}
                      offset={page * limit}
                    />
                  );
                })}
            </CheckCircleGroup>
          </FlexChild>

          {(setPage || output) && (
            <HorizontalFlex padding={"0px 20px 0px 20px"}>
              {setPage && maxPage > 1 && (
                <>
                  <FlexChild></FlexChild>
                  <HorizontalFlex>
                    <Move
                      name="《"
                      onClick={() =>
                        setPage(
                          Math.max(
                            0,
                            page % 10 >= 1
                              ? page - (page % 10)
                              : page - 10 - (page % 10)
                          )
                        )
                      }
                      disabled={page === 0}
                    />
                    <Move
                      name="〈"
                      onClick={() => setPage(Math.max(0, page - 1))}
                      disabled={page === 0}
                    />
                    <Page page={page} maxPage={maxPage} setPage={setPage} />
                    <Move
                      name="〉"
                      disabled={page === Math.ceil(maxPage - 1)}
                      onClick={() =>
                        setPage(Math.min(Math.ceil(maxPage - 1), page + 1))
                      }
                    />
                    <Move
                      name="》"
                      disabled={page === Math.ceil(maxPage - 1)}
                      onClick={() =>
                        setPage(
                          Math.min(
                            Math.ceil(maxPage - 1),
                            page % 10 < 9
                              ? page + 9 - (page % 10)
                              : page + 10 - (page % 10)
                          )
                        )
                      }
                    />
                  </HorizontalFlex>
                </>
              )}
              <FlexChild justifyContent={"flex-end"} gap={10}>
                {output &&
                  (Array.isArray(output) ? (
                    output?.length > 0 &&
                    output?.map((out, index) => (
                      <ExcelDownloadButton
                        empty={out?.empty || []}
                        key={`exec_${index}`}
                        data={data}
                        output={out}
                        indexes={indexes}
                      />
                    ))
                  ) : (
                    <ExcelDownloadButton
                      empty={output?.empty || []}
                      data={data}
                      output={output}
                      indexes={indexes}
                    />
                  ))}
              </FlexChild>
            </HorizontalFlex>
          )}
        </VerticalFlex>
      )}
    </div>
  );
}
const Move = ({ name, onClick, disabled }) => {
  return (
    <FlexChild>
      <AdminCustomButton onClick={onClick} disabled={disabled} text={name} />
    </FlexChild>
  );
};
const Page = ({ page, maxPage, setPage }) => {
  const start = page - (page % 10);
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
    .map((n) => start + n)
    .filter((n) => n < maxPage)
    .map((n) => (
      <FlexChild>
        <AdminCustomButton
          style={{ wordBreak: "keep-all" }}
          // className={clsx({ "bg-red": n === page })}
          selected={n === page}
          onClick={() => setPage(n)}
          text={n + 1}
        />
      </FlexChild>
    ));
};
const SimpleTableRow = forwardRef((props, ref) => {
  const { data, header, type, index: rowIndex, offset } = props;
  const { t } = useTranslation();
  const [isChecked, setChecked] = useState(false);
  const [checkedData, setCheckedData] = useState();
  const input = useRef();
  const checkboxCallback = (index, state) => {
    if (props.callback) {
      props.callback(index, state);
    }
  };

  useEffect(() => {
    if (data) {
      setCheckedData(data);
    }
  }, [data]);

  useEffect(() => {
    if (checkedData) {
    }
  }, [checkedData]);

  useEffect(() => {
    if (props.checkedIndex && props.checkedIndex.includes(props.index)) {
      input.current.setChecked(true);
    } else {
      input.current.setChecked(false);
    }
  }, [props.checkedIndex]);

  useImperativeHandle(ref, () => ({
    isChecked() {
      return isChecked;
    },
    setChecked(value) {
      input.current.setChecked(value);
    },
    isCheckedVaild() {
      return input.current.isChecked();
    },
  }));
  const onCopy = async (col, value) => {
    if (col.ellipsis_copy) {
      await window.navigator.clipboard.writeText(value);
      toast.success(`${col.text}을 복사했습니다.`, {
        autoClose: 1000,
        position: "bottom-center",
      });
    }
  };
  const ellipsis = {
    wordBreak: "keep-all",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  };

  return (
    <div
      className={style.productWrap}
      key={`row_${props.key}`}
      style={{ borderBottom: "1px solid #a0a0a0" }}
    >
      <HorizontalFlex
        gap={30}
        justifyContent={props.justifyContent}
        style={{ paddingBottom: 15 }}
      >
        <FlexChild width={30}>
          <div className={style.checkboxArea}>
            <CheckCircle
              ref={input}
              key={`${data?.id}`}
              callback={checkboxCallback}
              index={props.index}
              label={props.label}
              checkedData={checkedData}
            />
          </div>
        </FlexChild>
        {/* {
                    header && header.map((col, index) => {
                        
                        
                        return (
                            <FlexChild key={index} width={col.width}>
                                <P>{data[col.code]}</P>
                            </FlexChild>
                        );
                    }
                    )
                } */}
        {header &&
          header.map((col, index) => {
            const cellData = col?.code ? data[col?.code] : null;

            let displayValue = "";
            if (col?.Cell) {
              // return col?.cell?.(data, cellData, index);
              displayValue = col?.Cell({
                row: data,
                cell: cellData,
                index: offset + rowIndex,
              });
              const origin = displayValue;
              const type = col?.type ? col.type : typeof displayValue;
              if (type === "number") {
                displayValue = (
                  <P
                    hover={col.hover}
                    cursor={col.cursor}
                    textAlign={col.textAlign || "end"}
                    {...(col.ellipsis ? ellipsis : {})}
                  >
                    {displayValue?.toLocaleString("ko")}
                  </P>
                );
                if (col.ellipsis_hover)
                  displayValue = (
                    <ToolTip
                      style={{
                        width: "max-content",
                        zIndex: 1,
                        backgroundColor: "white",
                        padding: 5,
                        cursor: col.ellipsis_copy ? "pointer" : null,
                      }}
                      title={displayValue}
                      onClick={() => onCopy(col, origin)}
                    >
                      {displayValue}
                    </ToolTip>
                  );
              } else if (type === "string") {
                displayValue = (
                  <P
                    hover={col.hover}
                    cursor={col.cursor}
                    textAlign={col.textAlign}
                    {...(col.ellipsis ? ellipsis : {})}
                  >
                    {displayValue}
                  </P>
                );
                if (col.ellipsis_hover)
                  displayValue = (
                    <ToolTip
                      style={{
                        width: "max-content",
                        zIndex: 1,
                        backgroundColor: "white",
                        padding: 5,
                        cursor: col.ellipsis_copy ? "pointer" : null,
                      }}
                      title={displayValue}
                      onClick={() => onCopy(col, origin)}
                    >
                      {displayValue}
                    </ToolTip>
                  );
              }
            } else if (typeof cellData === "string") {
              displayValue = (
                <P
                  hover={col.hover}
                  cursor={col.cursor}
                  textAlign={col.textAlign}
                  {...(col.ellipsis ? ellipsis : {})}
                >
                  {cellData}
                </P>
              );
              if (col.ellipsis_hover)
                displayValue = (
                  <ToolTip
                    style={{
                      width: "max-content",
                      zIndex: 1,
                      backgroundColor: "white",
                      padding: 5,
                      cursor: col.ellipsis_copy ? "pointer" : null,
                    }}
                    title={displayValue}
                    onClick={() => onCopy(col, cellData)}
                  >
                    {displayValue}
                  </ToolTip>
                );
            } else if (typeof cellData === "number") {
              displayValue = (
                <P
                  hover={col.hover}
                  cursor={col.cursor}
                  textAlign={col.textAlign || "end"}
                  {...(col.ellipsis ? ellipsis : {})}
                >
                  {cellData?.toLocaleString("ko")}
                </P>
              );
              if (col.ellipsis_hover)
                displayValue = (
                  <ToolTip
                    style={{
                      width: "max-content",
                      zIndex: 1,
                      backgroundColor: "white",
                      padding: 5,
                      cursor: col.ellipsis_copy ? "pointer" : null,
                    }}
                    title={displayValue}
                    onClick={() => onCopy(col, cellData)}
                  >
                    {displayValue}
                  </ToolTip>
                );
            } else {
              displayValue = (
                <P
                  hover={col.hover}
                  cursor={col.cursor}
                  textAlign={col.textAlign}
                  {...(col.ellipsis ? ellipsis : {})}
                >
                  데이터 없음
                </P>
              );
              if (col.ellipsis_hover)
                displayValue = (
                  <ToolTip
                    style={{
                      width: "max-content",
                      zIndex: 1,
                      backgroundColor: "white",
                      padding: 5,
                      cursor: col.ellipsis_copy ? "pointer" : null,
                    }}
                    title={displayValue}
                  >
                    {displayValue}
                  </ToolTip>
                );
            }

            return (
              <FlexChild key={index} width={col.width}>
                <div
                  onClick={() =>
                    col?.onClick?.({ row: data, cell: cellData, index: index })
                  }
                  hover={col.hover}
                  cursor={col.cursor}
                  style={col.style}
                >
                  {displayValue}
                </div>
              </FlexChild>
            );
          })}
      </HorizontalFlex>
    </div>
  );
});

export default SimpleTable;
